import GraphsPage from './container'

export default GraphsPage
